import React from "react";
import SubNav from "../../../Shared/SubNav";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../../../context/socket";

const FinancisBetter = () => {
  const location = useLocation();
  const sessionId = new URLSearchParams(location.search).get("id");
  const navigate = useNavigate();

  const handleNext = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const nextUrl = "/my-cash-flow?clientId=" + roomId;

    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const prevUrl = "/financial-plan?clientId=" + roomId;

    console.log("here");
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };
  return (
    <>
      <div className="container minht">
      <div className="row ">
                <div className="col-lg-9 col-md-12">
                    <h2>Great! Let's try to understand your finances better</h2>
                    <p>Let’s dive a little deeper to understand your monthly budgeting. This will help us
                        understand <br/> a bit more about your household income and expenses.</p>
                </div>
                <div className="col-lg-3 col-md-12">
                    <img src="assets/images/Artificial-intelligence.svg" alt="" className="Artificial"/>
                </div>
            </div>
        {/* <div className="row pt-5">


          <div className="col-lg-8 col-md-12">
            <h2>Great! Let's try to understand your finances better</h2>
            <p>
              Let’s dive a little deeper to understand your monthly budgeting.
              This will help us understand <br /> a bit more about your
              household income and expenses.
            </p>
          </div>
          <div className="col-lg-4 col-md-12">
           <div className="d-flex align-items-end">
           <img
              src="assets/images/Artificial-intelligence.svg"
              alt=""
              className="Artificial"
            />
            <div className="container">
              <div className="row my-4">
                <div className="col text-end">
                  <a href="javascript:void(0);" onClick={handleBack}>
                    <img
                      className="arrow_next1"
                      src="assets/images/left-arrowpng.png"
                      alt=""
                    />
                  </a>
                  <a
                    href="javascript:void(0);"
                    className="ms-1"
                    onClick={handleNext}
                  >
                    <img
                      className="arrow_next"
                      src="assets/images/right-arrow.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
           </div>
          </div>
        </div> */}
      </div>
      <div className="container">
        <div className="row mb-4">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
        </div>
    </>
  );
};

export default FinancisBetter;
